export enum EPreDefinedDates {
  CUSTOM = 'CUSTOM',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS',
  LAST_THIRTY_DAYS = 'LAST_THIRTY_DAYS',
  THIS_MONTH = 'THIS_MONTH',
}
